import React from "react";

export default function TeenpattiMuflis() {
  return (
    <div className="center-main-container casino-page">
      <div className="center-container">
        <div className="casino-page-container teenpattimuflis">
          <div className="casino-header">
            <span className="casino-name">
              Muflis Teenpatti
              <a className="ms-1">
                <small>Rules</small>
              </a>
            </span>
            <span className="casino-rid d-none d-xl-inline-block">
              <small>
                Round ID: <span>138250501131946</span>
              </small>
            </span>
          </div>
          <div className="casino-title-header-mobile d-xl-none">
            <ul className="nav nav-tabs menu-tabs">
              <li className="nav-item">
                <div className="nav-link active">Game</div>
              </li>
              <li className="nav-item">
                <div className="nav-link">Placed Bet (0)</div>
              </li>
            </ul>
            <div className="pe-2">
              <span className="casino-rid">
                Round ID: <span>138250501131946</span>
              </span>
            </div>
          </div>
          <div className="">
            <div className="casino-video">
              <div className="video-box-container">
                <div className="casino-video-box">
                  {/* <iframe src="/mediaplayer/teenmuf/92d2ad53-bc06-44fc-9140-36b01cd0260b?ip=122.160.119.41" /> */}
                </div>
              </div>
              <div className="casino-video-cards">
                <div className="">
                  <div className="flip-card-container">
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-1">
                  <div className="flip-card-container">
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="clock flip-clock-wrapper">
            <ul className="flip play">
              <li className="flip-clock-before">
                <a href="#">
                  <div className="up">
                    <div className="shadow" />
                    <div className="inn">2</div>
                  </div>
                  <div className="down">
                    <div className="shadow" />
                    <div className="inn">2</div>
                  </div>
                </a>
              </li>
              <li className="flip-clock-active">
                <a href="#">
                  <div className="up">
                    <div className="shadow" />
                    <div className="inn">1</div>
                  </div>
                  <div className="down">
                    <div className="shadow" />
                    <div className="inn">1</div>
                  </div>
                </a>
              </li>
            </ul>
            <ul className="flip play">
              <li className="flip-clock-before">
                <a href="#">
                  <div className="up">
                    <div className="shadow" />
                    <div className="inn">3</div>
                  </div>
                  <div className="down">
                    <div className="shadow" />
                    <div className="inn">3</div>
                  </div>
                </a>
              </li>
              <li className="flip-clock-active">
                <a href="#">
                  <div className="up">
                    <div className="shadow" />
                    <div className="inn">2</div>
                  </div>
                  <div className="down">
                    <div className="shadow" />
                    <div className="inn">2</div>
                  </div>
                </a>
              </li>
            </ul>
          </div> */}
            </div>
            <div className="casino-detail">
              <div className="casino-table">
                <div className="casino-table-box">
                  <div className="casino-table-left-box">
                    <div className="casino-table-header">
                      <div className="casino-nation-detail">Player A</div>
                    </div>
                    <div className="casino-table-body">
                      <div className="casino-table-row">
                        <div className="casino-odds-box">Winner</div>
                        <div className="casino-odds-box">Top 9</div>
                        <div className="casino-odds-box">M Baccarat A</div>
                      </div>
                      <div className="casino-table-row">
                        <div className="casino-odds-box back">
                          <span className="casino-odds">1.98</span>
                        </div>
                        <div className="casino-odds-box back">
                          <span className="casino-odds">A</span>
                        </div>
                        <div className="casino-odds-box back">
                          <span className="casino-odds">1.95</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="casino-table-box-divider" />
                  <div className="casino-table-right-box">
                    <div className="casino-table-header">
                      <div className="casino-nation-detail">Player B</div>
                    </div>
                    <div className="casino-table-body">
                      <div className="casino-table-row">
                        <div className="casino-odds-box">Winner</div>
                        <div className="casino-odds-box">Top 9</div>
                        <div className="casino-odds-box">M Baccarat B</div>
                      </div>
                      <div className="casino-table-row">
                        <div className="casino-odds-box back">
                          <span className="casino-odds">1.98</span>
                        </div>
                        <div className="casino-odds-box back">
                          <span className="casino-odds">B</span>
                        </div>
                        <div className="casino-odds-box back">
                          <span className="casino-odds">1.95</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="casino-last-result-title">
                <span>Last Result</span>
                <span>
                  <a href="/casino-results/teenmuf">View All</a>
                </span>
              </div>
              <div className="casino-last-results">
                <span className="result result-b">B</span>
                <span className="result result-b">B</span>
                <span className="result result-b">B</span>
                <span className="result result-a">A</span>
                <span className="result result-a">A</span>
                <span className="result result-b">B</span>
                <span className="result result-b">B</span>
                <span className="result result-a">A</span>
                <span className="result result-a">A</span>
                <span className="result result-b">B</span>
              </div>
              <div className="sidebar-box my-bet-container mt-2 d-xl-none">
                <div className="sidebar-title">
                  <h4>Rules</h4>
                </div>
                <div className="">
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th colSpan={2} className="text-center">
                            Top 9
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Card 9</td>
                          <td>1 TO 3</td>
                        </tr>
                        <tr>
                          <td>Card 8</td>
                          <td>1 TO 4</td>
                        </tr>
                        <tr>
                          <td>Card 7</td>
                          <td>1 TO 5</td>
                        </tr>
                        <tr>
                          <td>Card 6</td>
                          <td>1 TO 8</td>
                        </tr>
                        <tr>
                          <td>Card 5</td>
                          <td>1 TO 30</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="d-none">
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>Matched Bet</th>
                    <th className="text-end">Odds</th>
                    <th className="text-end">Stake</th>
                  </tr>
                </thead>
                <tbody />
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className="sidebar right-sidebar casino-right-sidebar">
        <div className="sidebar-box my-bet-container">
          <div className="sidebar-title">
            <h4>My Bet</h4>
          </div>
          <div className="my-bets">
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>Matched Bet</th>
                    <th className="text-end">Odds</th>
                    <th className="text-end">Stake</th>
                  </tr>
                </thead>
                <tbody />
              </table>
            </div>
          </div>
        </div>
        <div className="sidebar-box my-bet-container">
          <div className="sidebar-title">
            <h4>Rules</h4>
          </div>
          <div className="">
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th colSpan={2} className="text-center">
                      Top 9
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Card 9</td>
                    <td>1 TO 3</td>
                  </tr>
                  <tr>
                    <td>Card 8</td>
                    <td>1 TO 4</td>
                  </tr>
                  <tr>
                    <td>Card 7</td>
                    <td>1 TO 5</td>
                  </tr>
                  <tr>
                    <td>Card 6</td>
                    <td>1 TO 8</td>
                  </tr>
                  <tr>
                    <td>Card 5</td>
                    <td>1 TO 30</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
